import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface WishlistItem {
  mappingCode: string;
}

interface WishlistState {
  items: WishlistItem[];
}

const initialState: WishlistState = {
  items: [],
};

const wishlistSlice = createSlice({
  name: "wishlist",
  initialState,
  reducers: {
    // Add to wishlist
    addToWishlist: (state, action: PayloadAction<{ mappingCode: string   }>) => {
      const { mappingCode} = action.payload;

      // Validate product ID
      if (!mappingCode || typeof mappingCode !== "string") {
        console.warn("Invalid product ID:", mappingCode);
        return;
      }

      // Check if already in wishlist
      const existingItem = state.items.find((item) => item.mappingCode === mappingCode);
      if (existingItem) {
        return; // Already in wishlist, don't add duplicate
      }

      state.items.push({ mappingCode });
    },

    // Remove from wishlist
    removeFromWishlist: (state, action: PayloadAction<string>) => {
      const mappingCode = action.payload;

      if (!mappingCode || typeof mappingCode !== "string") {
        console.warn("Invalid product ID:", mappingCode);
        return;
      }

      state.items = state.items.filter((item) => item.mappingCode !== mappingCode);
    },

    // Update quantity in wishlist
    updateWishlistQty: (state, action: PayloadAction<{ mappingCode: string; qty: number }>) => {
      const { mappingCode } = action.payload;

      // Validate inputs
      if (!mappingCode || typeof mappingCode !== "string") {
        console.warn("Invalid product data:", { mappingCode });
        return;
      }

    },

    // Clear entire wishlist
    clearWishlist: (state) => {
      state.items = [];
    },

    // Set entire wishlist (for hydration from storage)
    setWishlist: (state, action: PayloadAction<WishlistItem[]>) => {
      const items = action.payload;

      // Validate and filter items
      if (Array.isArray(items)) {
        state.items = items.filter(
          (item) => item.mappingCode && typeof item.mappingCode === "string"
        );
      }
    },
  },
});

export const { addToWishlist, removeFromWishlist, updateWishlistQty, clearWishlist, setWishlist } =
  wishlistSlice.actions;
export default wishlistSlice.reducer;
